var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"myVideo",attrs:{"autoplay":"","muted":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("../assets/images/water.mp4"),"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }